/**
 * Try to find first valid element (input, button, multiselect) in directive element, if not found return the element itself
 * @param el
 * @returns
 */
export const findElement = (el: HTMLElement, tryUseFirstElement: boolean = true) => {
  let elements: HTMLElement[] = [];

  //get the first input element on element (components wrapping elements)
  const inputElement = el.querySelector("input");
  if (inputElement && inputElementTypes.includes((inputElement as HTMLInputElement).type)) {
    elements.push(inputElement as HTMLElement);
  }

  const buttonElement = el.querySelector("button");
  if (buttonElement) {
    elements.push(buttonElement as HTMLElement);
  }

  const multiSelectElement = el.querySelector(".multiselect") ?? el.querySelector(".multiselect-wrapper");
  if (multiSelectElement) {
    elements.push(multiSelectElement as HTMLElement);
  }

  if (tryUseFirstElement && elements.length > 1) {
    console.warn(`Multiple elements found in directive element, using first element found - `, elements[0]);
  }

  return tryUseFirstElement ? elements[0] ?? el : el;
};

export const inputElementTypes: string[] = ["checkbox", "radio", "text"];
